
module.exports = {
  key: "b9e5cdbbf332091d9b5950283ff8995c",
  base: "https://api.openweathermap.org/data/2.5/",
};
